import React,{useState} from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Select from 'react-select'
import { editCustomerAdmin } from "../../redux/AdminReducer";
import Nav from "react-bootstrap/Nav";
import { FiEdit2 } from 'react-icons/fi';
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
// import './EditVehicleDrawer.css'
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector } from "react-redux";
import { updateVehicle } from "../../redux/AdminReducer";
import { updateDriver } from "../../redux/AdminReducer";

import { useDispatch } from "react-redux";

import Swal from "sweetalert2";
const EditCusomerDriver = (props) => {
  const dispatch=useDispatch();
  const getCustomersData=useSelector((state)=>state?.AdminReducer?.getCustomersData);
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );

  console.log("props?.data?.type",props?.data)
  const [vehicle,setVehicle]=useState({
    name:props?.data?.name,
    email:props?.data?.email,
    phone:props?.data?.phone,

    password:'',

     

  });
  console.log("vehicle",vehicle)
  const options = [
    { value: 'Mercedes E', label: 'Mercedes E' },
    { value: 'Mercedes V', label: 'Mercedes V' },
    { value: 'Mercedes S', label: 'Mercedes S' }
  ]
  const [imageVehicle, setImageVehicle] = useState();
  const handleChange=(e)=>{

    const{name,value}=e.target;

    console.log("e...............",e)

    setVehicle({
      ...vehicle,[name]:value
    })

  }
  const availabilityChange=(e)=>{

    

    console.log("vehiclevehicle",vehicle)

    setVehicle({
      ...vehicle,availability:!vehicle.availability
    })

  }


  const handleImage=(e)=>{
    const selected1 = e.target.files[0];

    setImageVehicle(selected1);

  }

  console.log("props?.data?._id",props?.data?._id)

  const addBtnClicked=async()=>{

    const data = new FormData();
    data.append("name", vehicle.name);
    data.append("email", vehicle.email);
    data.append("phone", vehicle.phone);
    data.append("password", vehicle.password);

  
   let id=props?.data?._id;
   const response=await dispatch(editCustomerAdmin({id,vehicle,getCustomersData}))

console.log("response",response?.payload?.message)

    
  }
  const handleChangeType=(e)=>{
    console.log("handleChangeTypee",e.value)

    setVehicle({...vehicle,type:e.value})

  }
  const defaultValue = { value:vehicle.type, label:vehicle.type }; // set the second option (Banana) as the default value

  return (
    <>
        {[false].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="mb-3">
          <Container fluid>
            {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}

            <Navbar.Toggle
aria-controls={`offcanvasNavbar-expand-${expand}`}
className="btnEditVehicle"
>
<FiEdit2/>
</Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              className="addVehicleDrawer"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Edit Driver
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mainAddVehicleDrawerFields">
                
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Name :</div>
                    <input
                      placeholder="Please Enter Name"
                      className="inputFieldAddVeh"
                      name="name"
                      value={vehicle.name}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Email :</div>
                    <input
                      placeholder="Please Enter Company Name"
                      className="inputFieldAddVeh"
                      name="email"
                      value={vehicle.email}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Phone Number :</div>
                    <input
                      placeholder="Please Enter Phone Number"
                      className="inputFieldAddVeh"
                      name="phone"
                      value={vehicle.phone}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                 
                 

                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Password :</div>
                    <input
                      placeholder="Please Enter  Password"
                      className="inputFieldAddVeh"
                      name="password"
                      // value={vehicle.password}
                      type="password"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
               
              
                  <div className="topCatagoryField topCatagoryFieldCheck">
                   
                  <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
             <button className="cnclBtn">
                        Cancel
                    </button>
            </Navbar.Toggle>
               
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
                    
                    <button className="addBtn" onClick={addBtnClicked}>
                        Update
                        </button>
                        </Navbar.Toggle>
                  </div>
                </div>
                
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default EditCusomerDriver;







